import React, { useEffect } from "react";
import { Button, Table } from "antd";
import { useModel, useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '公司',
        dataIndex: 'orgName',
        align: 'left',
    },
    {
        title: '区域编号',
        dataIndex: 'areaCode',
        align: 'left',
    },
    {
        title: '区域名称',
        dataIndex: 'areaName',
        align: 'left',
    },
    {
        title: '仓库',
        dataIndex: 'warehouseName',
    },
    {
        title: '备注',
        dataIndex: 'areaDesc',
    },

];

export default function () {
    const [
        { areaList, selectedArea, areaSelectedRowKeys, tabsKey, selectedWarehouse },
        { setAreaDrawerVisible, setSelectedArea, setAreaActionType, setAreaSelectedRowKeys, loadArea }
    ] = useModel("warehouse")
    const [{ userInfo }] = useModel("global");
    useEffect(() => {
        loadArea({ showMsg: false, data: { warehouseId: selectedWarehouse ? selectedWarehouse.id : '', orgId: userInfo.orgId, pageSize: 100, pageNum: 1 } });
    }, [tabsKey])
    const onAdd = () => {
        setAreaDrawerVisible(true);
        setAreaActionType(CM_ACTION_TYPE.INSERT);
    }
    const onEdit = () => {
        setAreaDrawerVisible(true);
        setAreaActionType(CM_ACTION_TYPE.EDIT);
    }
    return (
        <>
            <div style={{ margin: "0 0 8px" }}>
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_AREA_AD}>
                    <Button type="primary" onClick={onAdd}>新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_W_ED_AREA_ED}>
                    <Button className="margin-left-8" onClick={onEdit} disabled={!!!selectedArea}>编辑</Button>
                </YhAuth>
            </div>

            <Table
                columns={columns}
                dataSource={areaList}
                bordered
                pagination={false}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedArea && selectedArea.key === record.key) {
                                // console.log(record)
                                setSelectedArea(null);
                                setAreaSelectedRowKeys([]);
                            } else {
                                // console.log(record)
                                setSelectedArea(record);
                                setAreaSelectedRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedArea(selectedRows[0]);
                        setAreaSelectedRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled',
                        name: record.name,
                    }),
                    selectedRowKeys: areaSelectedRowKeys,
                }}
                scroll={{ x: 'max-content' }}
            />
        </>
    )
}